import axios from "axios"
import {configuration} from "../../appConfig"
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import {token} from "../../appTokenConfig";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');
var setOrderId;
var setVin;
var setActualVin;

const getDentFromResultJSON = async (vin) => {
    const partnerId = localStorage.getItem("partnerId");
    const res = await axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    );
    if (res.data) {
      setOrderId= res.data.OrderNo;
      setVin= res.data.Vin;
      setActualVin= res.data.ActualVin; 
      return res.data
    } else {
      alert("Error!...ResultDat file not available.");
      return false;
    }
  };


  const customerInfo = async (vin) => {
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      const res = await axios.get(
        configuration.getCustomerInfo +
        "?partnerId=" +
        partnerId +
        "&vin=" +
        vin
      );
      if (res.data.length) {
        return res.data[0];
      }
    } else {
      var emptyResultSet = {};
      return emptyResultSet;
    }
  };

  const getFallBackPricePerHour = async () => {
    const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
    let price;
    await axios.get(url)
    .then((res) => {
        if(res.data && res.data.PricePerHour) {
          price = res.data.PricePerHour
        } else {
          price = 145
        }
    })
    return price;
  }

  function findWithAttr(array, attr, value) {
    for(var i = 0; i < array.length; i += 1) {
        if(array[i][attr] === value) {
            return i;
        }
    }
    return -1;
  }

  const WorkTime = (AWa, AWb,part,data) => {
    if(part === 'TrunkCover') {
      AWa = AWa + data[findWithAttr(data, 'Part', 'Trunk')].AWa
      AWb = AWb + data[findWithAttr(data, 'Part', 'Trunk')].AWb
      data[findWithAttr(data, 'Part', 'Trunk')].AWa = 0
      data[findWithAttr(data, 'Part', 'Trunk')].AWb = 0
      if(AWa < AWb && AWa > 0){
        AWa = (AWa * 0.7);
      } else if(AWa > AWb && AWb > 0){
        AWb = (AWb * 0.7);
      } else if (AWa === AWb && AWa > 0 && AWb > 0) {
        AWa = (AWa * 0.7);
      }
    } else {
      if(AWa < AWb && AWa > 0){
        AWa = (AWa * 0.7);
      } else if(AWa > AWb && AWb > 0){
        AWb = (AWb * 0.7);
      } else if (AWa === AWb && AWa > 0 && AWb > 0) {
        AWa = (AWa * 0.7);
      }
    }
   let totalAWaAWb = AWa + AWb;
   if(totalAWaAWb > 111){
    totalAWaAWb = 111
   }

    let WorkTime = (totalAWaAWb / 10).toFixed(2) 
    return parseFloat(WorkTime);
  }

  const repairPositionsSWISS = async (partsArray) => {
    let datInformation = {
      backFender : {
          Description: "Seitenteil außen",
          DescriptionId: 39149070,
          ParentDATProcessId: 0,
          ConstructionGroupId: 12,
          ConstructionGroup: "HINTERWAGEN AUSSEN",
          ConstructionGroupPolygon: 19
      },
      frontFender : {
          Description : "Kotflügel",
          DescriptionId: 76406,
          ParentDATProcessId: 0,
          ConstructionGroupId: 1,
          ConstructionGroup: "VORDERWAGEN AUSSEN",
          ConstructionGroupPolygon: 3
      },
      backDoor : {
          Description : "Hintertür",
          DescriptionId: 181520,
          ParentDATProcessId: 24111,
          ConstructionGroupId: 11,
          ConstructionGroup: "TUER DOPPELKABINE H.",
          ConstructionGroupPolygon: 11
      },
      TrunkCover : {
          Description : 'Ladeklappe',
          DescriptionId: 254090,
          ParentDATProcessId: 0,
          ConstructionGroupId: 12,
          ConstructionGroup: "HINTERWAGEN AUSSEN",
          ConstructionGroupPolygon: 42
      },
      Hood : {
          Description : "Motorhaube",
          DescriptionId: 76254,
          ParentDATProcessId: 0,
          ConstructionGroupId: 1,
          ConstructionGroup: "VORDERWAGEN AUSSEN",
          ConstructionGroupPolygon: 26 
      },
      Roof : {
          Description : "Dach",
          DescriptionId: 11489568,
          ParentDATProcessId: "",
          ConstructionGroupId: 10,
          ConstructionGroup: "FAHRGASTZELLE DOPPELKABINE",
          ConstructionGroupPolygon: 33 
      },
      frame : {
          Description : "Dachrahmen 1",
          DescriptionId: 6709277,
          ParentDATProcessId: "",
          ConstructionGroupId: 10,
          ConstructionGroup: "FAHRGASTZELLE DOPPELKABINE",
          ConstructionGroupPolygon: 6
      },
      frontDoor : {
          Description : "Tür",
          DescriptionId: 77066,
          ParentDATProcessId: "",
          ConstructionGroupId: 4,
          ConstructionGroup: "TUER V.",
          ConstructionGroupPolygon: 19
      },
    }
    var repairPositionXmlTemplate = `<ns2:RepairPosition>
                    <ns2:DATProcessId/>
                    <ns2:RepairType>overhaul</ns2:RepairType>
                    <ns2:Description/>
                    <ns2:DescriptionId/>
                    <ns2:IsManualDescription>false</ns2:IsManualDescription>
                    <ns2:PositionEntryType>dents</ns2:PositionEntryType>
                    <ns2:IsRepairExtension>false</ns2:IsRepairExtension>
                    <ns2:ConstructionGroupId/>
                    <ns2:ConstructionGroup/>
                    <ns2:ConstructionGroupPolygon/>
                    <ns2:ConstructionType>3</ns2:ConstructionType>
                    <ns2:QuantityUnit>m</ns2:QuantityUnit>
                    <ns2:WorkType>other</ns2:WorkType>
                    <ns2:WorkTime/>
                    <ns2:DentsSize>25</ns2:DentsSize>
                    <ns2:DentsCalculationMethod>vffs-aseai</ns2:DentsCalculationMethod>
                    <ns2:DentsWithFinishing>false</ns2:DentsWithFinishing>
                    <ns2:IsAdditionalLM>false</ns2:IsAdditionalLM>
                    <ns2:PreDamage>false</ns2:PreDamage>
                    <ns2:DentsPartOrientation>horizontal</ns2:DentsPartOrientation>
                    <ns2:DentNumberLess/>
                    <ns2:DentNumberMore/>
                    <ns2:DentsWithSetupTime>true</ns2:DentsWithSetupTime>
                    <ns2:AdditionLM>false</ns2:AdditionLM>
                    <ns2:ContainMicroDents>false</ns2:ContainMicroDents>
                    <ns2:WorkIndication>1</ns2:WorkIndication>
                </ns2:RepairPosition>`;
    var repairPositionXml;
    if (partsArray) {
      const newXML = partsArray
      .map((record, i) => {
          let extraPart = ['Trunk',"LeftFrontTyre","LeftBackTyre","RightFrontTyre","RightBackTyre","FrontBumper","BackBumper","Underbody","Inside"].includes(record.Part)
          let frame= ['RightRoofFrame','LeftRoofFrame'].includes(record.Part)
          let frontDoor = ["LeftFrontDoor","RightFrontDoor"].includes(record.Part)
          let backFender = ["LeftBackFender","RightBackFender"].includes(record.Part)
          let frontFender = ["LeftFrontFender","RightFrontFender"].includes(record.Part)
          let backDoor = ["LeftBackDoor","RightBackDoor"].includes(record.Part)
          const {AWa,AWb,Datcode,A,B,C,Part} = record 
          let datObj = Part;
          if(extraPart){
            return;
          }
          if(frame) {
            datObj = "frame"
          } else if(frontDoor){
            datObj = "frontDoor"
          } else if(backFender) {
            datObj = "backFender"
          } else if(frontFender) {
            datObj = "frontFender"
          } else if(backDoor) {
            datObj = "backDoor"
          }
          repairPositionXml = repairPositionXmlTemplate.replace(
            "<ns2:DATProcessId/>",
            "<ns2:DATProcessId>" + Datcode + "</ns2:DATProcessId>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:Description/>",
            "<ns2:Description>" + datInformation[datObj]['Description'] + "</ns2:Description>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:DescriptionId/>",
            "<ns2:DescriptionId>" + datInformation[datObj]['DescriptionId'] + "</ns2:DescriptionId>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:ConstructionGroupId/>",
            "<ns2:ConstructionGroupId>" + datInformation[datObj]['ConstructionGroupId'] + "</ns2:ConstructionGroupId>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:ConstructionGroup/>",
            "<ns2:ConstructionGroup>" + datInformation[datObj]['ConstructionGroup'] + "</ns2:ConstructionGroup>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:ConstructionGroupPolygon/>",
            "<ns2:ConstructionGroupPolygon>" + datInformation[datObj]['ConstructionGroupPolygon'] + "</ns2:ConstructionGroupPolygon>"
          );
          repairPositionXml = repairPositionXml.replace(
            "<ns2:DentNumberLess/>",
            "<ns2:DentNumberLess>" + (Part === 'TrunkCover' ? (A + (partsArray[findWithAttr(partsArray, 'Part', 'Trunk')].A || 0)) : A) + "</ns2:DentNumberLess>"
          );

          repairPositionXml = repairPositionXml.replace(
            "<ns2:DentNumberMore/>",
            "<ns2:DentNumberMore>" + (Part === 'TrunkCover' ? ((parseInt(B) + (partsArray[findWithAttr(partsArray, 'Part', 'Trunk')].B || 0)) + (parseInt(C ? C : 0) + (partsArray[findWithAttr(partsArray, 'Part', 'Trunk')].C || 0))) : (parseInt(B) + parseInt(C ? C : 0)))  + "</ns2:DentNumberMore>"
          );

          repairPositionXml = repairPositionXml.replace(
            "<ns2:DATProcessId/>",
            "<ns2:DATProcessId>" + Datcode + "</ns2:DATProcessId>"
          );

          repairPositionXml = repairPositionXml.replace(
            "<ns2:WorkTime/>",
            
            `<ns2:WorkTime>${WorkTime(AWa,AWb,Part,partsArray)}</ns2:WorkTime>`
          );
          return repairPositionXml;
        })
        .join(""); //join function will remove comma
      // map function ends
      return "<ns2:RepairPositions>" + newXML + "</ns2:RepairPositions>";
    }
  };

  const getName = (fullName, isFirstName) => {
    if(fullName) {
      const spaceIndex = fullName.indexOf(" ");
      const firstName = fullName.slice(0, spaceIndex);
      const lastName = fullName.slice(spaceIndex + 1);
      if(isFirstName) {
        return firstName || '';
      } else {
        return lastName || '';
      }
    } else {
      return "";
    }
  }

  const getLanguage = () => {
    const language = localStorage.getItem('lang');
    if(language === 'fr') {
      return 'fr_CH';
    } else if(language === 'it') {
      return 'it_CH';
    } else {
      return 'de_CH';
    }
  }

  const getDateTime = (date) => {
    if (!date) {
        console.error("Date is undefined.");
        return null;
    }

    if (!date.includes('_')) {
        console.error("Invalid date format.");
        return null;
    }

    const dateParts = date.split('_');
    const formattedDate = new Date(`${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`);

    const isoString = formattedDate.toISOString();

    // Get the time zone offset in minutes
    const offsetMinutes = formattedDate.getTimezoneOffset();

    // Calculate the time zone offset in hours and convert it to a string
    const offsetHours = Math.abs(Math.floor(offsetMinutes / 60)).toString().padStart(2, '0');

    // Determine the sign of the offset (+ or -)
    const offsetSign = offsetMinutes < 0 ? '+' : '-';

    // Construct the final formatted date string
    const formattedDateTime = isoString.slice(0, 10) + offsetSign + offsetHours + ':00';

    return formattedDateTime;
}


const connectDATSWISS = async (row, type) => {
    var options = {
      compact: true,
      ignoreComment: true,
      spaces: 4,
      trim: true,
    };
    const confirm = true;
    if (confirm) {
      const resultDatJSON = await getDentFromResultJSON(row.vin);
      let customerInfoData = await customerInfo(row.vin);
      const actualVIN = resultDatJSON.ActualVin;
      const resultDatJSONParts = resultDatJSON.Dents;
      const PricePerHour = resultDatJSON.hasOwnProperty("PricePerHour") ? resultDatJSON.PricePerHour :  await getFallBackPricePerHour(); 
      if (true) {
        let newOrderXML = await axios.get("/DAT/newOrderSWISS.xml");
        var repairPositionsXml = await repairPositionsSWISS(resultDatJSONParts);
        newOrderXML = newOrderXML.data.replace(
          "<ns2:Name/>",
          "<ns2:Name>" + row.vin.split("_")[0] + "</ns2:Name>"
        );
        
        newOrderXML = newOrderXML.replace(
          "<ns2:Language />",
          "<ns2:Language>" + getLanguage() + "</ns2:Language>"
        );

        newOrderXML = newOrderXML.replace(
          "<ns2:Description/>",
          "<ns2:Description>" + row.vin.split("_")[0] + "</ns2:Description>"
        );
        newOrderXML = newOrderXML.replace(
          "<ns2:JobNumber/>",
          `<ns2:JobNumber>${row.vin.split("_")[0]}</ns2:JobNumber>`
        );
        
        newOrderXML = newOrderXML.replace(
          "<ns2:OrderNumber />",
          `<ns2:OrderNumber>${row.vin.split("_")[0]}</ns2:OrderNumber>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:VinCode/>",
          `<ns2:VinCode>${actualVIN.split("_")[0]}</ns2:VinCode>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:VehicleIdentNumber/>",
          "<ns2:VehicleIdentNumber>" +
            actualVIN.split("_")[0] +
            "</ns2:VehicleIdentNumber>"
        );
        newOrderXML = newOrderXML.replaceAll(
          "<ns2:NameLong/>",
          `<ns2:NameLong>${resultDatJSON.PartnerName}</ns2:NameLong>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:OwnerLastName />",
          `<ns2:LastName>${getName(resultDatJSON.PartnerName || '',1)}</ns2:LastName>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:OwnerFirstName />",
          `<ns2:FirstName>${getName(resultDatJSON.PartnerName || '',0)}</ns2:FirstName>`
        );
        
        newOrderXML = newOrderXML.replaceAll(
          "<ns2:FirstName />",
          `<ns2:FirstName>${getName(resultDatJSON.AuthorizedName || '',1)}</ns2:FirstName>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:LastName />",
          `<ns2:LastName>${getName(resultDatJSON.AuthorizedName || '',0)}</ns2:LastName>`
        );
        
        newOrderXML = newOrderXML.replaceAll(
          "<ns2:InsuranceCompanyName />",
          `<ns2:CompanyName>${resultDatJSON.Client ? resultDatJSON.Client : resultDatJSON.InsurenceName}</ns2:CompanyName>`
        );
        
        newOrderXML = newOrderXML.replaceAll(
          "<ns2:DamageNumber />",
          `<ns2:DamageNumber>${resultDatJSON.ClaimNo || ''}</ns2:DamageNumber>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:InspectionDate />",
          `<ns2:InspectionDate>${getDateTime(resultDatJSON.Datetime)}</ns2:InspectionDate>`
        );

        newOrderXML = newOrderXML.replaceAll(
          "<ns2:LicenseNumber/>",
          `<ns2:LicenseNumber>${resultDatJSON.RegNo}</ns2:LicenseNumber>`
        );
        newOrderXML = newOrderXML.replaceAll(
          "<PricePerHour />",
          PricePerHour
        );
        
        newOrderXML = newOrderXML.replace(
          "<ns2:RepairPositions/>",
          repairPositionsXml
        );

        if (customerInfoData != undefined) {
          if (Object.keys(customerInfoData).length > 0) {
            if (customerInfoData.kilometerStand != "") {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:MileageOdometer />",
                "<ns2:MileageOdometer>" + customerInfoData.kilometerStand + "</ns2:MileageOdometer>"
              );
            }
            else {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:MileageOdometer />",
                "<ns2:MileageOdometer>" + "0" + "</ns2:MileageOdometer>"
              );
            }

            if (customerInfoData.manufacturer != "") {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:ManufacturerName />",
                `<ns2:ManufacturerName origin="dat">${customerInfoData.manufacturer}</ns2:ManufacturerName>`
              );
            }
            else {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:ManufacturerName />",
                `<ns2:ManufacturerName origin="dat"></ns2:ManufacturerName>`
              );
            }

            if (customerInfoData.model != "") {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:BaseModelName />",
                `<ns2:BaseModelName origin="dat">${customerInfoData.model}</ns2:BaseModelName>`
              );
            }
            else {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:BaseModelName />",
                `<ns2:BaseModelName origin="dat"></ns2:BaseModelName>`
              );
            }

            if (customerInfoData.color != "") {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:Color />",
                `<ns2:Color origin="dat">${customerInfoData.color}</ns2:Color>`
              );
            }
            else {
              newOrderXML = newOrderXML.replaceAll(
                "<ns2:Color />",
                `<ns2:Color origin="dat"></ns2:Color>`
              );
            }
          }
          else {
            newOrderXML = newOrderXML.replaceAll(
              "<ns2:MileageOdometer/>",
              "<ns2:MileageOdometer>" + "0" + "</ns2:MileageOdometer>"
            );
          }
        }

        var d = new Date();
        var n = d.getSeconds();
        newOrderXML = newOrderXML.replace(
          "<ns2:CreateDate/>",
          "<ns2:CreateDate>" + d + "</ns2:CreateDate>"
        );

        newOrderXML = newOrderXML.replace(
          "<ns2:ChangeDate/>",
          "<ns2:ChangeDate>" + d + "</ns2:ChangeDate>"
        );

        var finalXML = newOrderXML;

        if (finalXML) {
          var blob = new Blob([finalXML], {
            type: "text/plain;charset=utf-8",
          });
          saveAs(blob, row.vin + "_vxs.xml");
          datReportDownload(row.vin, type);
        }
      }
    }
    return false;
  };

  const internalStatus = async (vin) => {
    const url = configuration.internalStatus;
    let payload = {
      vin: setOrderId || vin || setActualVin,
      status: 1,
    }
   const headers = {
    Authorization: `Bearer ${token}`,
   };
    await axios.post(url, payload, { headers })
  }

  const storeLog = async (vin, type) => {
    const url = configuration.storeLog;
    let payload = {
      partner_id: localStorage.getItem("partnerId"), 
      vin: vin,
      is_type : type,
    }
    await axios.post(url, payload)
  }
  
  const datReportDownload = (vin, type) => {
    let partnerId = localStorage.getItem("partnerId");
    let url = `${configuration.datReportCheck}?partnerId=${partnerId}&vin=${vin}`;
    let getDataUrl = `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`;
    const updateJSONUrl =`${configuration.PostEditorChanges}?partnerId=${partnerId}&vin=${vin}`;
    axios.post(url)
    .then((res) => {
      setOrderId= res.data.OrderNo;
      setVin= res.data.Vin;
      setActualVin= res.data.ActualVin; 
      if(res.data.status === 200) {
        storeLog(vin, type);
        internalStatus(vin);
        axios.get(getDataUrl)
        .then((res) => {
          setOrderId= res.data.OrderNo;
          setVin= res.data.Vin;
          setActualVin= res.data.ActualVin; 
          if(!(res.data.hasOwnProperty('DATReportDownloaded') && res.data.DATReportDownloaded)){
            let payload = {
              ...res.data,
              DATReportDownloaded : true
            }
            axios.post(updateJSONUrl,payload)
            .then((res) => {
              if(res.data.status === 200){
                Toast.fire({
                  type: "success",
                  title: "DAT download successfully!",
                });
              } else {
                Toast.fire({
                  type: "error",
                  title: "Something went wrong!",
                });
              }
            })
            .catch((err) => {
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            })
          }
          else{
            Toast.fire({
              type: "success",
              title: "DAT download successfully!",
            });
          }
        })
      } else {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      }
    })
    .catch((err) => {
      Toast.fire({
        type: "error",
        title: "Something went wrong!",
      });
    }) 

  }

export default connectDATSWISS;